import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import moment from 'moment';
import { OiqSmsAlert } from './sms-alerts.service';

@Component({
  selector: 'oiq-notification-sms-alerts-list',
  templateUrl: './sms-alerts-list.component.html',
  styleUrls: ['../events/events-list.component.scss'],
  imports: [RouterLink],
})
export class OiqNotificationSmsAlertsListComponent {
  private static readonly PREVIEW_LENGTH = 120;

  @Input() items: OiqSmsAlert[] = [];
  @Output() event = new EventEmitter<{ type: 'open'; data: OiqSmsAlert }>();

  getFormatFromNow(datetime: string) {
    return moment(datetime).fromNow();
  }

  preview(body: string): string {
    const max = OiqNotificationSmsAlertsListComponent.PREVIEW_LENGTH;
    return body.length > max ? `${body.slice(0, max).trimEnd()}…` : body;
  }
}
